import {create} from "zustand";

export const useIsModal = create((set) => ({
    isModal: false,
    setIsModal: (value) => {
        set(() => ({isModal: value}))
    }
}))
